import { createStore } from 'redux';
import { loadState, saveState } from './localStorage';
import sessionModalReducer from "./sessionModalSlice";
import { getStoredTheme } from '../theme';


const counterReducer = (state = {
    count: 0,
    countInvoiceToCheck: 0,
    /* Ulazne fakture dodeljene BAŠ MENI koje još nisam proverio.
       Odvojeno od `countInvoiceToCheck`, koji broji IZLAZNE na overi. */
    ulazneZaMene: 0,
    /* Prihvaćene SEF ulazne koje još nisu zavedene (podtab „Fakture za unos“). */
    ulazneZaUnos: 0,
    countAvansAlarm: 0,
    unreadChat: 0,
    planNeprocitani: 0,
    planNovi: 0,
    user: {},
    /* Putanja do avatara iz ćaskanja. Svoj ključ, jer se `user` pravi iznova
       pri svakoj prijavi i prebacivanju firme, pa bi se avatar gubio. */
    avatar: null,
    user_role: {},
    company: {},
    company_sub_u_sub: {},
    trip: null,
    vehicle: null,
    employee: null,
    eskaliran: null,
    permissions: null,
    sessionModal: { visible: false, type: 'INFO', payload: null },
    invoice: null,
    tureSearchPutni: '',
    tureSearchRadni: '',
    /* Početna tema se čita odatle odakle je čita i `index.js` pri pokretanju
       (localStorage.appTheme). Da je ovde ostalo tvrdo `light`, prekidač bi
       posle osvežavanja stranice pokazivao svetlu temu iako je aplikacija
       iscrtana tamna ili retro. */
    theme: getStoredTheme()
}, action) => {

    const nextSessionModal = sessionModalReducer(state.sessionModal, action);
    const base = { ...state, sessionModal: nextSessionModal };

    if(action.type === 'CHAT_UNREAD_INC')      return { ...base, unreadChat: (state.unreadChat || 0) + 1 };
    if(action.type === 'CHAT_UNREAD_DEC')      return { ...base, unreadChat: Math.max(0, (state.unreadChat || 0) - (action.value ?? 0)) };
    if(action.type === 'CHAT_UNREAD_RESET')    return { ...base, unreadChat: 0 };
    if(action.type === 'CHAT_UNREAD_SET')      return { ...base, unreadChat: action.value || 0 };
    if(action.type === 'PLAN_NOVI_SET')        return { ...base, planNovi: action.value };
    /* Odvojeno od planNovi: broj otvorenih zadataka i broj onih na kojima
       ceka nova poruka nisu isti podatak i ne smeju da se saberu. */
    if(action.type === 'PLAN_NEPROCITANI_SET') return { ...base, planNeprocitani: action.value };
    if(action.type === 'AVANS_ALARM_SET')      return { ...base, countAvansAlarm: action.value || 0 };
    if(action.type === 'COUNTER')              return { ...base, count: action.value };
    if(action.type === 'COUNTER_INVOICE_CHECK') return { ...base, countInvoiceToCheck: action.value };
    if(action.type === 'ULAZNE_ZA_MENE_SET')    return { ...base, ulazneZaMene: action.value || 0 };
    if(action.type === 'ULAZNE_ZA_UNOS_SET')    return { ...base, ulazneZaUnos: action.value || 0 };
    if(action.type === 'USER')                 return { ...base, user: action.value };
    if(action.type === 'AVATAR_SET')           return { ...base, avatar: action.value || null };
    if(action.type === 'USER_ROLE')            return { ...base, user_role: action.value };
    if(action.type === 'COMPANY')              return { ...base, company: action.value };
    if(action.type === 'COMPANY_SUB_U_SUB')    return { ...base, company_sub_u_sub: action.value };
    if(action.type === 'TRIP')                 return { ...base, trip: action.value };
    if(action.type === 'VEHICLE')              return { ...base, vehicle: action.value };
    if(action.type === 'EMPLOYEE')             return { ...base, employee: action.value };
    if(action.type === 'ESKALIRAN')            return { ...base, eskaliran: action.value };
    if(action.type === 'PERMISSIONS')          return { ...base, permissions: action.value };
    if(action.type === 'INVOICE')              return { ...base, invoice: action.value };
    if(action.type === 'TURE_SEARCH_PUTNI')    return { ...base, tureSearchPutni: action.value || '' };
    if(action.type === 'TURE_SEARCH_RADNI')    return { ...base, tureSearchRadni: action.value || '' };
    /* Tri teme, ne dve: sve što nije poznato pada na svetlu. Ranije je ovde
       stajalo `=== 'dark' ? 'dark' : 'light'`, pa bi retro bio tiho pretvoren
       u svetlu — aplikacija bi ostala retro (to ide preko `data-theme`), a
       prekidač bi pokazivao svetlu. */
    if(action.type === 'THEME_SET')            return { ...base, theme: ['light', 'dark', 'retro', 'retrodark'].includes(action.value) ? action.value : 'light' };

    if(nextSessionModal !== state.sessionModal) return base;

    return state;
};

const persistedState = loadState();

const store = createStore(counterReducer, persistedState);

store.subscribe(() => {
    saveState(store.getState());
});

export default store;
